export class ServiceTask {
    id: number|undefined;
    active:boolean;
    code:string;
    name:string;
    description:string;
  }